<div class="app-container mat-app-background">
    <div class="header">
        <nav>
            <header></header>
        </nav>
    </div>

    <div class="content" id="content">
        <router-outlet (activate)="onActivate()"></router-outlet>
        <footer></footer>

    </div>
    <ng-template #countryDialog>
        <country-choose></country-choose>
    </ng-template>

    <ng-template #cookieDialog>
        <div class="cookie-banner">
            <div class="cookie">Мы используем cookies для запоминания вашего региона и удобства использования сайта.
                Эти cookies не содержат персональных данных и не передаются третьим сторонам.</div>
            <div class="cookie-buttons">
                <button mat-button class=" main-button cookie-button" [mat-dialog-close]="true" (click)="acceptCookies()">ОК</button>
                <button mat-button  class="cookie-button more-info" (click)="navigate('/cookie-policy')"  >Подробнее</button>
            </div>


        </div>
    </ng-template>

</div>


